'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var style = require('../../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const PickupWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-rjya10-0"
})(["text-align:center;display:flex;flex-direction:column;align-items:center;"]);
const Divider = styled__default["default"].hr.withConfig({
  componentId: "sc-rjya10-1"
})(["border:0 none;border-bottom:1px solid;width:100%;", " margin:1.25rem 0;"], _ref => {
  let {
    theme
  } = _ref;
  return theme.panelcontainerNoneNone;
});
const TimeslotTitle = styled__default["default"].h3.withConfig({
  componentId: "sc-rjya10-2"
})([""]);
const TimeslotDate = styled__default["default"].div.withConfig({
  componentId: "sc-rjya10-3"
})(["", " font-weight:700;margin-bottom:24px;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return style.getFontSizing(theme.headersBigNone, {
    fontSize: '24px'
  });
});
const TimeslotDescription = styled__default["default"].div.withConfig({
  componentId: "sc-rjya10-4"
})(["", ""], _ref3 => {
  let {
    theme
  } = _ref3;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px'
  });
});
const PickupLocationTitle = styled__default["default"].h3.withConfig({
  componentId: "sc-rjya10-5"
})([""]);
const PickupLocationDescription = styled__default["default"].div.withConfig({
  componentId: "sc-rjya10-6"
})(["margin-bottom:32px;"]);
const PickupLocationAddress = styled__default["default"].address.withConfig({
  componentId: "sc-rjya10-7"
})(["font-style:normal;", " margin-bottom:32px;"], _ref4 => {
  let {
    theme
  } = _ref4;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px'
  });
});
const PickupHandoffWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-rjya10-8"
})(["margin-bottom:32px;"]);
const PickupHandoffTitle = styled__default["default"].h3.withConfig({
  componentId: "sc-rjya10-9"
})([""]);
const PickupLocationToggle = styled__default["default"].button.withConfig({
  componentId: "sc-rjya10-10"
})(["font-weight:700;text-decoration:none;font-family:inherit;border:0 none;background:transparent;cursor:pointer;", " ", " @media (hover:hover){&:hover{", "}}"], _ref5 => {
  let {
    theme
  } = _ref5;
  return style.getFontSizing(theme.headersMediumNone, {
    fontSize: '16px'
  });
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.linksNoneDefault;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.linksNoneHover;
});
const PickupLocationInputWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-rjya10-11"
})(["position:relative;width:100%;max-width:400px;"]);
const Counter = styled__default["default"].div.withConfig({
  componentId: "sc-rjya10-12"
})(["position:absolute;bottom:10px;right:10px;color:#767676;font-family:inherit;", ""], _ref8 => {
  let {
    theme
  } = _ref8;
  return style.getFontSizing(theme.captiontextDefaultNone, {
    fontSize: '12px'
  });
});
const PickupLocationInput = styled__default["default"].textarea.withConfig({
  componentId: "sc-rjya10-13"
})(["width:100%;height:100px;resize:none;padding:10px;box-sizing:border-box;"]);
styled__default["default"].h3.withConfig({
  componentId: "sc-rjya10-14"
})([""]);
styled__default["default"].div.withConfig({
  componentId: "sc-rjya10-15"
})([""]);

exports.Counter = Counter;
exports.Divider = Divider;
exports.PickupHandoffTitle = PickupHandoffTitle;
exports.PickupHandoffWrapper = PickupHandoffWrapper;
exports.PickupLocationAddress = PickupLocationAddress;
exports.PickupLocationDescription = PickupLocationDescription;
exports.PickupLocationInput = PickupLocationInput;
exports.PickupLocationInputWrapper = PickupLocationInputWrapper;
exports.PickupLocationTitle = PickupLocationTitle;
exports.PickupLocationToggle = PickupLocationToggle;
exports.PickupWrapper = PickupWrapper;
exports.TimeslotDate = TimeslotDate;
exports.TimeslotDescription = TimeslotDescription;
exports.TimeslotTitle = TimeslotTitle;
